<div class="card mb-4" [class.mb-4]="to.topBottomPadding !== false">

  <div class="card-body" [class.py-0]="to.topBottomPadding === false">
    <h3 class="card-title mb-3" *ngIf="to.label">{{ to.label }}</h3>
    <div>
      <ng-container #fieldComponent></ng-container>
    </div>
  </div>
</div>
